/**
 * Created by Andrey Popov on 12/29/25.
 */

const CustomerInfoView = cc.Node.extend({
    ctor: function (info) {
        this._super();

        this.recipe = info.recipe;
        const onTap = () => Map2d.currentMap.customers.selectCustomer(info.customer);
        const isExactStage = Boolean(info.customer && info.customer.exactStageIngredients);
        this.customerIngredientViews = info.recipe.getIngredients().map((ingredient, index, ingredients) => {
            const ingredientView = new CustomerIngredientView(ingredient, CustomerIngredientView.TYPE_INFOVIEW, { onTap, isExactStage });
            ingredientView.setLocalZOrder(ingredients.length - index);
            return ingredientView;
        });

        const styles = cleverapps.styles.CustomerInfoView;
        const ingredientsLayout = new cleverapps.Layout(this.customerIngredientViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        const timer = CustomerInfoView.createOrderTimer(info.customer);
        this.content = timer ? new cleverapps.Layout([timer, ingredientsLayout], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.timer.margin,
            padding: { top: styles.timer.padding }
        }) : ingredientsLayout;

        const contentSize = this.content.getContentSize();
        if (timer) {
            contentSize.width = Math.max(contentSize.width, timer.width + styles.timer.padding * 2);
        }

        this.background = InfoView.CreateInfoBackground(contentSize);
        this.addChild(this.background);

        this.setContentSize2(contentSize);
        this.background.setContentSize(contentSize);

        this.content.setAlignment(this.width / 2, this.height / 2);
        this.background.setAlignment(this.width / 2, this.height / 2);
        this.addChild(this.content);

        Map2d.currentMap.customers.on("onRecipesUpdated", this.onRecipesUpdated.bind(this), this);
    },

    onRecipesUpdated: function () {
        if (this.recipe.wasCooking() || !this.isRunning()) {
            return;
        }
        let justGotReady = false;
        this.customerIngredientViews.forEach((ingredientView) => {
            if (ingredientView.onAmountChanged()) {
                justGotReady = true;
            }
        });

        if (justGotReady) {
            this.runAction(new cc.Sequence(
                new cc.ScaleTo(0.26, 0.93, 0.85).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.2, 1.05).easing(cc.easeInOut(1)),
                new cc.ScaleTo(0.067, 1).easing(cc.easeInOut(1))
            ));
        }
    }
});

CustomerInfoView.createOrderTimer = function (customer) {
    if (typeof HungryGamesCustomer === "undefined" || !customer) {
        return undefined;
    }

    const hungryGamesCustomer = customer.unit.findComponent(HungryGamesCustomer);
    if (!hungryGamesCustomer || !hungryGamesCustomer.hasLevelTimer() || customer.getState() !== Customer.STATE_RECIPE) {
        return undefined;
    }

    const styles = cleverapps.styles.CustomerInfoView.timer;

    return new cleverapps.CountDownView(new cleverapps.CountDown(hungryGamesCustomer.getTimeLeft()), {
        font: cleverapps.styles.FONTS.COMPONENT_TIMER_NO_BAR_TEXT,
        showHours: false,
        background: {
            frame: bundles.small_timer.frames.small_timer_bg_png,
            width: styles.width,
            height: styles.height
        },
        icon: {
            frame: bundles.small_timer_merge.frames.timer_png
        }
    });
};

cleverapps.styles.CustomerInfoView = {
    margin: 24,

    padding: {
        x: 30,
        top: 12,
        bottom: 16
    },

    timer: {
        width: 105,
        height: 34,
        margin: 6,
        padding: 14
    }
};